import { render, staticRenderFns } from "./hidden.vue?vue&type=template&id=8e24766e&"
import script from "./hidden.vue?vue&type=script&lang=js&"
export * from "./hidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e24766e')) {
      api.createRecord('8e24766e', component.options)
    } else {
      api.reload('8e24766e', component.options)
    }
    module.hot.accept("./hidden.vue?vue&type=template&id=8e24766e&", function () {
      api.rerender('8e24766e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/form-templates/hidden.vue"
export default component.exports